export default "<ng-template #anchor></ng-template>\r\n<p class=\"control-wrapper-error-message\" *ngIf=\"errorMessage\">\r\n  {{ errorMessage }}\r\n</p>\r\n"